/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Members_Seat_Scheduled_Next_RenewalInputs */



/**
* | output |
* | --- |
* | "{type} from the next renewal" |
*
* @param {Members_Seat_Scheduled_Next_RenewalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_seat_scheduled_next_renewal = /** @type {((inputs: Members_Seat_Scheduled_Next_RenewalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Seat_Scheduled_Next_RenewalInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.type} ab der nächsten Verlängerung`)
	return /** @type {LocalizedString} */ (`${i?.type} from the next renewal`)
});